import Addon from "./addon.js";

class Cart {
  constructor(data) {
    this.plan = data['plan'];
    this.planQuantity = data['subscription[plan_quantity]'] || 1;
    this.addons = Addon.retrieve(data);
  }
}

export default Cart;




// WEBPACK FOOTER //
// ./src/models/cart.js